import request from '@/utils/request';

const baseURL = '/financeapi/finance/certificate/'

// 新增凭证
export const addCertificate = data =>
  request({
    data,
    url: `${baseURL}addCertificate`,
    method: 'post'
  });
export const exportSummaryCertificate = data =>
  request({
    data,
    url: `${baseURL}exportSummaryCertificate`,
    method: 'post'
  });
export const changeCertificateStatus = data =>
  request({
    data,
    url: `${baseURL}changeCertificateStatus`,
    method: 'post'
  });

export const deleteCertificate = data =>
  request({
    data,
    url: `${baseURL}deleteCertificate`,
    method: 'post'
  });

export const editCertificateDetails = data =>
  request({
    data,
    url: `${baseURL}editCertificateDetails`,
    method: 'post'
  });

// 凭证列表
export const findCertificates = data =>
  request({
    data,
    url: `${baseURL}findCertificates`,
    method: 'post'
  });

export const findCertificateJump = data =>
  request({
    data,
    url: `${baseURL}findCertificateJump`,
    method: 'post'
  });

export const getLatestCnum = data =>
  request({
    data,
    url: `${baseURL}getLatestCnum`,
    method: 'post'
  });

export const summaryCertificate = data =>
  request({
    data,
    url: `${baseURL}summaryCertificate`,
    method: 'post'
  });

export const findCertificateSwch = data =>
  request({
    data,
    url: `${baseURL}findCertificateSwch`,
    method: 'post'
  });

export const seachSubjectByKey = data =>
  request({
    data,
    url: `${baseURL}seachSubjectByKey`,
    method: 'post'
  });

export const offsetForCertificateNum = data =>
  request({
    data,
    url: `${baseURL}offsetForCertificateNum`,
    method: 'post'
  });

export const billsToCertificate = data =>
  request({
    data,
    url: `${baseURL}bills/billsToCertificate`,
    method: 'post'
  });

export const findBillDetail = data =>
  request({
    data,
    url: `${baseURL}bills/detail`,
    method: 'post'
  });

export const findbillsList = data =>
  request({
    data,
    url: `${baseURL}bills/findbillsList`,
    method: 'post'
  });
export const findbills = data =>
  request({
    data,
    url: `${baseURL}bills/findbills`,
    method: 'post'
  });

export const findErrorBusinessCertificate = data =>
  request({
    data,
    url: `${baseURL}bills/findErrorBusinessCertificate`,
    method: 'post'
  });

export const billsRebuildCertificate = data =>
  request({
    data,
    url: `${baseURL}bills/billsRebuildCertificate`,
    method: 'post'
  });

export const billsNotice = data =>
  request({
    data,
    url: `${baseURL}bills/notice`,
    method: 'post'
  });

export const billsRead = data =>
  request({
    data,
    url: `${baseURL}bills/read`,
    method: 'post'
  });

export const lastRecordTime = data =>
  request({
    data,
    url: `${baseURL}lastRecordTime`,
    method: 'post'
  });

export const findBusinessInoutDetail = data =>
  request({
    data,
    url: `${baseURL}business/inout/detail`,
    method: 'post'
  });
export const emptyCertificate = () => {
  const certificate = {
    cnum: '',
    dnum: 0,
    status: '',
    recordTime: '',
    createUser: '',
    verifierUser: '',
    billsList: [],
    uid: '',
    error: 0,
    certificateEntry: []
  };
  for (let i = 0; i < 2; i++) {
    certificate.certificateEntry.push({
      subjectUid: '',
      subjectCode: '',
      subjectName: '',
      digest: '',
      inMoney: 0,
      outMoney: 0,
      assists: []
    });
  }
  return certificate;
};
